import { render, staticRenderFns } from "./PageModel.vue?vue&type=template&id=4f3399e0&scoped=true&"
import script from "./PageModel.vue?vue&type=script&lang=js&"
export * from "./PageModel.vue?vue&type=script&lang=js&"
import style0 from "./PageModel.vue?vue&type=style&index=0&id=4f3399e0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3399e0",
  null
  
)

export default component.exports